export interface Range {
  min?: number;
  max?: number;
}

export function parse(range: string): Range {
  if (!range.match(/^([\d]+)?:([\d]+)?$/)) {
    throw new Error(`Invalid range format: ${range}`);
  }
  const result: Range = {};
  const [min, max] = range.split(':');

  if (min !== '') {
    result.min = parseFloat(min);
  }

  if (max !== '') {
    result.max = parseFloat(max);
  }

  return result;
}

export function stringify(range: Range): string {
  const min = range.min !== undefined ? range.min : '';
  const max = range.max !== undefined ? range.max : '';

  return `${min}:${max}`;
}

export function merge(...ranges: Range[]): Range {
  return ranges.reduce((current: Range, next: Range) => {
    if (next.min === undefined && typeof current.min === 'number') {
      next.min = current.min;
    }
    if (next.max === undefined && typeof current.max === 'number') {
      next.max = current.max;
    }
    return next;
  }, {});
}
